import { Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectorRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { MyApp } from 'src/app/api/helper/app';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { Utils } from 'src/app/api/helper/utils';
import { LieferantListItem } from 'src/app/api/model/model';
import { Adresse } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { SystemService } from 'src/app/api/system.service';

const log = new Logger("LieferantSuchenComponent");

@Component({
    selector: 'app-lieferant-suchen',
    templateUrl: './lieferant-suchen.component.html',
    styleUrls: ['./lieferant-suchen.component.scss'],
    standalone: false
})
export class LieferantSuchenComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    static instance: LieferantSuchenComponent;

    @ViewChild('searchbar', { static: false }) searchbar: IonSearchbar;

    @Input() items: LieferantListItem[];

    sichtbareItems: LieferantListItem[];

    isVisible = false;
    suchtext = '';

    constructor(
        private cdr: ChangeDetectorRef,
        private systemService: SystemService,
        private stammdatenService: StammdatenService,
        private remoteService: RemoteService,
        private modalController: ModalController,) {

        LieferantSuchenComponent.instance = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.auftrag) {
            this.refresh();
        }
    }

    ngOnDestroy(): void {
        this.isVisible = false;
        MyApp.loading(false);
    }

    async ngOnInit() {
        this.isVisible = true;
        this.sichtbareItems = [];

        if (!this.items) {
            await this.ladeAdressen(false);
        }

        for (const item of this.items) {
            if (item.adresse) {
                item.text = item.adresse.Name1;
                item.subtext = item.adresse.AdressNummer;

                if (item.adresse.Zusatzdaten?.BestellungVorhanden === '1') {
                    item.istFavorit = true;
                }

                item.suchtext = item.adresse.AdressNummer
                    + ';' + item.adresse.Name1
                    + ';' + item.adresse.Name2
                    + ';' + item.adresse.Ort
                    + ';' + item.adresse.Ansprechpartner;

            } else {
                item.text = '???';
                item.subtext = '';
                item.suchtext = '';
            }

            item.suchtext = item.suchtext.toLowerCase();
        }

        this.refresh();
    }

    async doRefresh(event) {
        log?.debug('doRefresh');

        await UiHelper.showLoading('Adressen werden geladen...');

        event.target.complete();

        try {
            await this.ladeAdressen(true);
        } catch (err) {
            UiHelper.showError(err);
        } finally {
            UiHelper.hideLoading();
        }
    }

    async ladeAdressen(force: boolean) {
        this.items = [];

        let adressen: Adresse[] = [];

        if (this.stammdatenService.lieferanten?.length && !force) {
            // Lieferanten wurden bereits geladen. Nicht erneut laden (kann manuell über den refresher gemacht werden)
            adressen = this.stammdatenService.lieferanten;
        } else {
            MyApp.loading(true);

            const result = await this.remoteService.sucheAdressen({
                AdressTyp: 'Lieferant',
                Suchtext: null
            });

            if (!this.isVisible) {
                return;
            }

            MyApp.loading(false);

            if (result?.Success && result.Adressen) {
                // Merke die Lieferanten für die nächste Abfrage
                this.stammdatenService.setLieferanten(result.Adressen);

                adressen = result.Adressen;
            } else if (result?.ErrorMessage) {
                UiHelper.showError(result.ErrorMessage);
            } else {
                UiHelper.showFehlerKommunikation();
            }
        }

        this.items = [];

        for (const adresse of adressen) {
            const item: LieferantListItem = {
                adresse: adresse,
            }

            this.items.push(item);
        }
    }

    async ngAfterViewInit() {
        log?.info('ngAfterViewInit');

        setTimeout(() => {
            if (this.searchbar) {
                try {
                    this.searchbar.setFocus();
                } catch (err) {
                    log.error('setTimeout onSuchen: ' + Utils.getErrorMessage(err), err);
                }
            }
        }, 500);
    }

    refresh() {
        log?.debug('refresh');
        this.filterSichtbareItems();
    }

    onClose() {
        log?.debug('onClose');
        this.modalController.dismiss(null);
    }

    onSearchChanged(e: Event) {
        this.filterSichtbareItems();

        this.cdr.detectChanges();
    }

    private filterSichtbareItems() {
        log?.debug('filterSichtbareItems');

        let sichtbareItems: LieferantListItem[];

        if (this.suchtext && this.suchtext.trim()) {
            sichtbareItems = [];

            const parts: string[] = this.suchtext.toLowerCase().trim().split(' ');

            for (const item of this.items) {
                let isMatch = true;

                for (const str of parts) {
                    if (!item.suchtext.includes(str)) {
                        isMatch = false;
                        break;
                    }
                }

                if (isMatch) {
                    sichtbareItems.push(item);
                }
            }
        } else {
            sichtbareItems = this.items;
        }

        this.sichtbareItems = sichtbareItems;

        this.cdr.detectChanges();
    }

    onAdresseSelected(item: LieferantListItem) {
        this.modalController.dismiss(item.adresse);
    }
}
